module.exports = __webpack_public_path__ + "fonts/Rubik-400-latin-ext17.15c3dca.woff2";